var map = {
	"./apple.svg": "1108",
	"./changeModule.svg": "1cf1",
	"./circle-highcolor--filled.svg": "0b06",
	"./circle-highcolor.svg": "1ccf",
	"./circle-lowcolor--filled.svg": "3965",
	"./circle-lowcolor.svg": "6f45",
	"./circle-normalcolor--filled.svg": "b6e2",
	"./circle-normalcolor.svg": "4ea0",
	"./diamond-highcolor.svg": "2a69",
	"./diamond-lowcolor.svg": "ed2d",
	"./diamond-normalcolor.svg": "831f",
	"./drug.svg": "6e98",
	"./legend-aidex-value.svg": "8d9b",
	"./legend-bg-value.svg": "5eb6",
	"./legend-cgm-value.svg": "88df",
	"./legend-diamond.svg": "44fc",
	"./legend-high.svg": "2e5f",
	"./legend-low.svg": "7916",
	"./legend-pump-value.svg": "fa61",
	"./needle.svg": "9496",
	"./pumpicon-alarm.svg": "689b",
	"./pumpicon-alarm2.svg": "7ca0",
	"./pumpicon-alarm3.svg": "3d22",
	"./pumpicon-basalrate.svg": "a604",
	"./pumpicon-bolus.svg": "8fd8",
	"./pumpicon-changemodule.svg": "e32c",
	"./pumpicon-clock.svg": "3efe",
	"./pumpicon-dual.svg": "70eb",
	"./pumpicon-extendedbolus.svg": "192b",
	"./pumpicon-needle.svg": "08e5",
	"./pumpicon-resovior2.svg": "4fb4",
	"./pumpicon-resovior3.svg": "1322",
	"./pumpicon-stopline.svg": "729c",
	"./pumpicon-upload.svg": "16a5",
	"./pumpicon-upload2.svg": "ced8",
	"./rect-highcolor.svg": "6937",
	"./rect-lowcolor.svg": "d7b9",
	"./rect-normalcolor.svg": "7739",
	"./sport.svg": "5cd0",
	"./triangle-highcolor.svg": "fed1",
	"./triangle-lowcolor.svg": "b144",
	"./triangle-normalcolor.svg": "5b9d",
	"./zebra-2.svg": "d226",
	"./zebra-3.svg": "7e83",
	"./zebra.svg": "84da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";